var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload-demo drag-upload",
          class: { disabledCard: _vm.uploadDisabled },
          attrs: {
            drag: _vm.drag,
            "show-file-list": "",
            "file-list": _vm.fileList,
            "before-upload": _vm.beforeAvatarUpload,
            action: _vm.action,
            "on-preview": _vm.handlePreview,
            "on-success": _vm.handleSuccess,
            "on-remove": _vm.handleRemove,
            accept: _vm.updateData.fileType,
            limit: _vm.limit,
            "on-change": _vm.handleChange,
            "auto-upload": false,
            data: _vm.uploadParams,
            "with-credentials": true
          }
        },
        [
          _vm.drag ? _c("i", { staticClass: "el-icon-upload" }) : _vm._e(),
          _vm._v(" "),
          _vm.drag
            ? _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("\n      将文件拖到此处，或\n      "),
                _c("em", [_vm._v("点击上传")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.updateData.updateMsg.length > 0 && _vm.tipPosition === "down"
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  staticStyle: {
                    "margin-left": "0rem",
                    width: "6rem",
                    "margin-top": "-0.2rem"
                  },
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v(_vm._s(_vm.updateData.updateMsg))]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.updateData.updateMsg.length > 0 && _vm.tipPosition === "left"
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [_vm._v(_vm._s(_vm.updateData.updateMsg))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "uploadView",
          attrs: {
            visible: _vm.dialogVisible,
            title: "附件查看",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", height: "5.66rem" } },
            [
              _vm.fileType === "jpg" ||
              _vm.fileType === "png" ||
              _vm.fileType === "gif" ||
              _vm.fileType === "jpeg"
                ? _c("img", {
                    staticStyle: { "max-width": "100%", "max-height": "100%" },
                    attrs: { src: _vm.dialogImageUrl, alt: "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.fileType === "mp4" || _vm.fileType === "mov"
                ? _c("video", {
                    attrs: {
                      src: _vm.dialogImageUrl,
                      alt: "",
                      controls: "controls",
                      height: "100%"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.fileType === "mp3" ||
              _vm.fileType === "wav" ||
              _vm.fileType === "mgg"
                ? _c("audio", {
                    attrs: {
                      src: _vm.dialogImageUrl,
                      controls: "",
                      width: "100%"
                    }
                  })
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-551540dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551540dd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXUpload/uploadFile2.vue
// module id = 513
// module chunks = 0